import React from "react";
import { Text } from "@chakra-ui/react";

const LoggedOut = () => {
  return (
    <div>
      <Text fontSize="6xl">Please login to manage your todos.</Text>
    </div>
  );
};

export default LoggedOut;
